import React, { useState, useEffect } from 'react';

import { useToggle } from '@hooks/useToggle';

const BlockWrapper = props => {

    const initialCoordinates = { x: 5, y: 5 };

    const [ position, updatePosition ] = useState(initialCoordinates);

    const [ isToggled, toggle ] = useToggle(false);

    const {
        id,
        children,
        additionalStyles
    } = props;

    const handleMouseOver = (e, color) => {
        e.currentTarget.style.backgroundColor = color;
    };

    const handleMouseLeave = (e, color) => {
        e.currentTarget.style.backgroundColor = color;
    };

    useEffect(() => {

        let x = position.x;
        let y = position.y;

        let shiftX = 0;
        let shiftY = 0;

        const updateCoors = e => {

            x = e.clientX + shiftX;
            y = e.clientY + shiftY;

            updatePosition({ x, y });
        };

        const updater = e => {

            if(!e.target.id.includes('draggable-bar')) {
                return null;
            }

            shiftX = x - e.clientX;
            shiftY = y - e.clientY;

            window.addEventListener('mousemove', updateCoors);
            window.addEventListener('mouseup', () => {
                window.removeEventListener('mousemove', updateCoors);
            });
        };

        window.addEventListener('mousedown', updater);

        return () => {
            window.removeEventListener('mousedown', updater);
        };

    }, [ isToggled ]);
    
    const buttonStyle = {
        position: 'absolute',
        right: 5,
        top: 5,
        backgroundColor: 'yellow',
        borderRadius: '1.8rem',
        height: '1.8rem',
        width: '1.8rem',
        cursor: 'pointer',
        fontSize: '1.0rem'
    };

    return (
        <div
            style={{
                position: 'fixed',
                left: position.x,
                top: position.y,
                backgroundColor: 'rgb(0, 128, 128, 0.9)',
                width: '550px',
                padding: '0.5rem',
                paddingTop: '40px',
                borderRadius: '1rem',
                zIndex: 2500,
                color: 'black',
                ...additionalStyles
            }}
        >
            <div
                id='draggable-bar'
                style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    borderRadius: '1rem',
                    border: '1px solid black',
                    width: additionalStyles && additionalStyles.width ? additionalStyles.width - 25 : 525,
                    height: 28,
                    position: 'fixed',
                    top: position.y + 5
                }}
            >
                <div
                    style={{
                        ...buttonStyle,
                        right: 30,
                        fontSize: '1.3rem'
                    }}
                    onClick={() => {
                        updatePosition(initialCoordinates);
                        toggle();
                    }}
                    onMouseEnter={e => handleMouseOver(e, 'red')}
                    onMouseLeave={e => handleMouseLeave(e, 'yellow')}
                >
                    <span

                        style={{
                            position: 'absolute',
                            left: '4px',
                            top: 0
                        }}

                    >
                    &#8662;
                    </span>
                </div>
                <div
                    id={ id }
                    style={ buttonStyle }
                    onMouseEnter={e => handleMouseOver(e, 'red')}
                    onMouseLeave={e => handleMouseLeave(e, 'yellow')}
                >
                    <span
                        id={ id }
                        style={{
                            position: 'absolute',
                            left: '5px',
                            top: '2px'
                        }}

                    >
                    X
                    </span>
                </div>
            </div>
            
            { children }
        </div>
    );
};

export default BlockWrapper;